var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlmr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.477 12.533c0 .094-.002.187-.004.28H9.415A9.533 9.533 0 0 1 18.944 3a9.533 9.533 0 0 1 9.534 9.533zm-22.15 2.383h-.84v.84h.84v-.84zm23.411 0H8.01v.84h21.728v-.84zM1.642 17.299H1v.84h.642v-.84zm17.863 0H2.925v.84h16.58v-.84zm-14.02 2.522h.842v.842h-.84v-.842zm2.524 0h21.728v.842H8.01v-.842zm-5.047 2.524H2.12v.84h.843v-.84zm1.682 0h8.411v.84H4.645v-.84zm9.533 0H31v.84H14.178v-.84zm1.121 2.803h.446v.84H15.3v-.84zm1.34 0h11.556v.84H16.641v-.84zm-6.388 2.523h-.84v.84h.84v-.84zm11.776 0H11.935v.84h10.093v-.84z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlmr);
export default __webpack_public_path__ + "static/media/GLMR.3f6ebfda450c7390b182d6c93f4193d0.svg";
export { ForwardRef as ReactComponent };